import React, { useState } from "react";
import { ValorFixo } from "../../../../../domain/models/city-adapter-config";
import * as S from "../styles";

type Props = {
  valores: ValorFixo[];
  onChange: (valores: ValorFixo[]) => void;
};

const ValoresFixosSection: React.FC<Props> = ({ valores, onChange }) => {
  const [novoCaminho, setNovoCaminho] = useState("");
  const [novoValor, setNovoValor] = useState("");
  const [novoSobrescrever, setNovoSobrescrever] = useState(true);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editCaminho, setEditCaminho] = useState("");
  const [editValor, setEditValor] = useState("");
  const [editSobrescrever, setEditSobrescrever] = useState(true);

  const handleAdd = (): void => {
    if (!novoCaminho.trim()) return;
    let parsedValor: unknown = novoValor;
    try {
      parsedValor = JSON.parse(novoValor);
    } catch {
      // mantém como string
    }
    onChange([...valores, { caminho: novoCaminho.trim(), valor: parsedValor, sobrescrever: novoSobrescrever }]);
    setNovoCaminho("");
    setNovoValor("");
    setNovoSobrescrever(true);
  };

  const handleRemove = (index: number): void => {
    onChange(valores.filter((_, i) => i !== index));
    if (editIndex === index) setEditIndex(null);
  };

  const handleStartEdit = (index: number): void => {
    const vf = valores[index];
    setEditIndex(index);
    setEditCaminho(vf.caminho);
    setEditValor(typeof vf.valor === "object" ? JSON.stringify(vf.valor) : String(vf.valor));
    setEditSobrescrever(vf.sobrescrever);
  };

  const handleSaveEdit = (): void => {
    if (editIndex === null || !editCaminho.trim()) return;
    let parsedValor: unknown = editValor;
    try {
      parsedValor = JSON.parse(editValor);
    } catch {
      // mantém como string
    }
    const updated = [...valores];
    updated[editIndex] = { caminho: editCaminho.trim(), valor: parsedValor, sobrescrever: editSobrescrever };
    onChange(updated);
    setEditIndex(null);
  };

  const handleCancelEdit = (): void => {
    setEditIndex(null);
  };

  return (
    <S.SectionCard>
      <S.SectionTitle>Valores Fixos</S.SectionTitle>
      <S.InfoBox>
        ℹ️ Campos configurados aqui serão <strong>adicionados</strong> ao JSON da nota antes do envio.
        Se o campo já existir e &quot;Sobrescrever&quot; estiver desativado, o valor original será mantido.
      </S.InfoBox>

      {valores.length > 0 && (
        <S.Table>
          <thead>
            <tr>
              <th>Caminho</th>
              <th>Valor</th>
              <th>Sobrescrever</th>
              <th aria-label="Ações" />
            </tr>
          </thead>
          <tbody>
            {valores.map((vf, i) => (
              editIndex === i ? (
                <tr key={`vf-edit-${i}`}>
                  <td><S.FormInput value={editCaminho} onChange={(e) => setEditCaminho(e.target.value)} style={{ minWidth: 100 }} /></td>
                  <td><S.FormInput value={editValor} onChange={(e) => setEditValor(e.target.value)} style={{ minWidth: 100 }} /></td>
                  <td>
                    <input type="checkbox" checked={editSobrescrever} onChange={(e) => setEditSobrescrever(e.target.checked)} />
                  </td>
                  <td>
                    <S.IconButton type="button" onClick={handleSaveEdit}>✅</S.IconButton>
                    <S.IconButton type="button" onClick={handleCancelEdit}>❌</S.IconButton>
                  </td>
                </tr>
              ) : (
                <tr key={`vf-${vf.caminho}-${i}`}>
                  <td><code>{vf.caminho}</code></td>
                  <td><code>{typeof vf.valor === "object" ? JSON.stringify(vf.valor) : String(vf.valor)}</code></td>
                  <td>{vf.sobrescrever ? "✅" : "❌"}</td>
                  <td>
                    <S.IconButton type="button" onClick={() => handleStartEdit(i)}>✏️</S.IconButton>
                    <S.IconButton type="button" onClick={() => handleRemove(i)}>🗑️</S.IconButton>
                  </td>
                </tr>
              )
            ))}
          </tbody>
        </S.Table>
      )}

      <S.FormRow>
        <S.FormInput
          placeholder="Caminho (ex: versaoEsquema)"
          value={novoCaminho}
          onChange={(e) => setNovoCaminho(e.target.value)}
          style={{ flex: 2 }}
        />
        <S.FormInput
          placeholder="Valor (ex: RTC ou {&quot;key&quot;: &quot;val&quot;})"
          value={novoValor}
          onChange={(e) => setNovoValor(e.target.value)}
          style={{ flex: 2 }}
        />
        <label htmlFor="sobrescrever-check" style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 12, whiteSpace: "nowrap", color: "#fff", fontFamily: "Poppins, sans-serif" }}>
          <input
            id="sobrescrever-check"
            type="checkbox"
            checked={novoSobrescrever}
            onChange={(e) => setNovoSobrescrever(e.target.checked)}
          />
          Sobrescrever
        </label>
        <S.SmallButton type="button" onClick={handleAdd}>+ Adicionar</S.SmallButton>
      </S.FormRow>
    </S.SectionCard>
  );
};

export default ValoresFixosSection;
